import React from 'react'

const Statement = () => {
  return (
    <>
      <h1 className='temp-h1'>Statement</h1>
    </>
  )
}

export default Statement